import { API } from "../../Services";

export const country = () =>{
    return (dispatch) =>{
        dispatch({
            type:"FETCH_COUNTRIES",
        })
         API.country().then((res)=>{
            let data = JSON.parse(JSON.stringify(res)).data.countries
            data.map((country,countryIndex)=>{
                country.value = country.code
                country.label = country.name
            })
            setTimeout(()=>{
                dispatch({
                    type:"RECEIVE_COUNTRIES",
                    payload:data,
                })
            },1000)
        }).catch((err)=>{
            dispatch({
                type:"ERROR_COUNTRIES",
            })
        })
    }
}